module.exports = __webpack_public_path__ + "odstraneni-tetovaze_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_7_before.jpg
// module id = 964
// module chunks = 0